import { useEffect, useState } from "react";

interface PDFViewerProps {
  fileUrl: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ fileUrl }) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let revokedUrl: string | null = null;

    const loadPdf = async () => {
      try {
        setError(null);

        const res = await fetch(fileUrl);

        if (!res.ok) {
          throw new Error(`Failed to fetch PDF: ${res.status}`);
        }

        const blob = await res.blob();
        // Ensure the blob has the correct MIME type
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfBlob);
        revokedUrl = url;
        setBlobUrl(url);
      } catch (e: any) {
        console.error(e);
        setError(e.message || "Failed to load PDF");
      }
    };

    loadPdf();

    return () => {
      if (revokedUrl) URL.revokeObjectURL(revokedUrl);
    };
  }, [fileUrl]);

  if (error) {
    return <div className="text-red-500 text-sm">Error loading PDF: {error}</div>;
  }

  if (!blobUrl) {
    return <div className="text-sm text-muted-foreground">טוען PDF…</div>;
  }

  return (
    <iframe
      src={blobUrl}
      className="w-full h-full rounded-lg border-0"
      title="PDF preview"
    />
  );
};

export default PDFViewer;
